export default {
    path: '/error',
    meta: {
        title: '错误',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/error`),
}


// WEBPACK FOOTER //
// ./src/views/error/router.js